import { render } from "./Prochip.vue?vue&type=template&id=603919b6&scoped=true"
import script from "./Prochip.vue?vue&type=script&lang=js"
export * from "./Prochip.vue?vue&type=script&lang=js"

import "./Prochip.vue?vue&type=style&index=0&id=603919b6&scoped=true&lang=css"

import exportComponent from "C:\\agent\\_work\\55\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603919b6"]])

export default __exports__